/**
 * 上报销售
 */
export default [
  {
    path: '/reportSales',
    component: () => import(/* webpackChunkName: "reportSales" */ '@/views/reportSales/Index.vue'),
    meta: { requiresAuth: true, title: '上报销售', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import(/* webpackChunkName: "reportSales" */ '@/views/reportSales/List.vue'),
          meta: { title: '上报销售', role: true },
        },
        {
          path: 'form',
          component: () => import(/* webpackChunkName: "reportSales" */ '@/views/reportSales/Form.vue'),
          meta: { title: '上报销售', role: true },
        },
        {
          path: 'status',
          component: () => import(/* webpackChunkName: "reportSales" */ '@/views/reportSales/Status.vue'),
          meta: { title: '上报销售', role: true },
        },
        // {
        // 	path: 'checkstatus',
        // 	component: () => import(/* webpackChunkName: "reportSales" */ '@/views/reportSales/CheckStatus.vue'),
        // 	meta: { title: '上报销售', role: true },
        // },

      ],
  }, {
    /** 商管端 重新复制一套商户，便于维护 */
    path: '/reviewSales',
    component: () => import(/* webpackChunkName: "reviewSales" */ '@/views/reviewSales/Index.vue'),
    meta: { requiresAuth: true, title: '上报销售审核', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import(/* webpackChunkName: "reviewSales" */ '@/views/reviewSales/List.vue'),
          meta: { title: '上报销售审核', role: true },
        },
        // {
        // 	path: 'form',
        // 	component: () => import(/* webpackChunkName: "reviewSales" */ '@/views/reviewSales/Form.vue'),
        // 	meta: { title: '上报销售', role: true },
        // },
        // {
        // 	path: 'status',
        // 	component: () => import(/* webpackChunkName: "reviewSales" */ '@/views/reviewSales/Status.vue'),
        // 	meta: { title: '上报销售详情', role: true },
        // },
        {
          path: 'checkstatus',
          component: () => import(/* webpackChunkName: "reviewSales" */ '@/views/reviewSales/CheckStatus.vue'),
          meta: { title: '上报销售', role: true },
        },

      ],
  }
];
